import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  paper: {
    position: 'relative',
    backgroundColor: 'transparent',
    border: '0',
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    outline: 'none',
    height: 'auto',
    width: '100%',
    [theme.breakpoints.up('viewportLarge')]: {
      maxWidth: '70.25rem',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      maxWidth: '110.375rem',
    },
  },
  modal_area: {
    position: 'relative',
    margin: '0.78125rem',
    [theme.breakpoints.up('viewportMediumMid')]: {
      margin: '1.875rem 5.9375rem',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      margin: '0 3.875rem',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      margin: '0 12.5rem',
    },
  },
  content: {
    position: 'relative',
    paddingBottom: '56.25%',
  },
  video_frame: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
});
